import type React from "react";

import { textStyles } from "@/lib/textStyles";
import { cn } from "@/lib/utils";
import { STATUS_CONFIG } from "@/features/patients/infrastructure/data/PatientDetailsStatus";

type StatusTone = "success" | "warning" | "error";

interface AssessmentStatusPillProps {
  status?: string | null;
  label?: string;
  tone?: StatusTone;
  className?: string;
}

const TONE_CLASS_NAMES: Record<StatusTone, string> = {
  success: "bg-[#E6F4EA] text-[#34A853]",
  warning: "bg-[#FFF4E5] text-[#E37400]",
  error: "bg-[#FDECEC] text-[#C62828]",
};

export const AssessmentStatusPill: React.FC<AssessmentStatusPillProps> = ({
  status,
  label,
  tone = "warning",
  className,
}) => {
  const statusConfig = status ? STATUS_CONFIG[status] : undefined;
  const pillLabel = statusConfig?.text ?? label ?? "Unknown Status";
  const toneClassName = statusConfig?.className ?? TONE_CLASS_NAMES[tone];

  return (
    <span
      className={cn(
        "inline-flex w-fit max-w-full items-center justify-center rounded-lg px-2 py-[5px] text-center",
        toneClassName,
        className,
      )}
    >
      <span className="break-words" style={textStyles.body}>
        {pillLabel}
      </span>
    </span>
  );
};
